<template lang="pug">
  .home-fraction-count-box.box.box-margin(v-cloak)
    .box-header(v-if="title")
      span.title {{ title }}
    .box-body
      .loading(v-if="isBusy")
        b-spinner.spinner
      .counts(v-else)
        span.value {{ molecule }}
        span.total /{{ denominator }}
        span.unit(v-if="unit") {{ unit }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * 今日の介護記録登録数コンポーネント
 */
@Component
export default class HomeFractionCountBox extends Vue {
  /** タイトル */
  @Prop({
    default: () => {
      return "";
    }
  })
  private title!: string;

  /** カウント数(分子)) */
  @Prop({
    default: () => {
      return "-";
    }
  })
  private molecule!: string | number;

  /** カウント数(分母)) */
  @Prop({
    default: () => {
      return "-";
    }
  })
  private denominator!: string | number;

  /** 単位 */
  @Prop({
    default: () => {
      return "";
    }
  })
  private unit!: string;

  /** ローディング表示可否 */
  @Prop({
    default: () => {
      return false;
    }
  })
  private isBusy!: boolean;

  /**
   * vue lifecycle created
   */
  private created(): void {
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/pc/_colors.scss";
@import "../../styles/pc/_mixin.scss";

.home-fraction-count-box {
  .box-header {
    padding-top: 6px;
    padding-bottom: 7px;

    .title {
      @include bold-font();
    }
  }
  .box-body {
    text-align: right;
    padding: 0;

    .loading {
      padding: 9px;
      .spinner {
        width: 30px;
        height: 30px;
        color: $loading;
      }
    }

    .counts {
      padding: 0 10px 0 0;
      .value {
        @include font(32px);
      }
      .total {
        @include font();
      }
      .unit {
        @include font();
      }
    }
  }
}
</style>
